module.exports = __webpack_public_path__ + "static/img/01038B_1_R_20200820_fit.219e04a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/01038B_1_R_20200820_fit.png
// module id = 190u
// module chunks = 0